module.exports = __webpack_public_path__ + "static/media/user-dropdown-company-profile.305653c5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/user-dropdown-company-profile.svg
// module id = 1486
// module chunks = 0